<app-header></app-header>
<!-- Banner Area Start -->
<section class="jobguru-banner-area">
  <div class="banner-slider owl-carousel">
    <div class="banner-single-slider slider-item-1">
      <div class="slider-offset"></div>
    </div>
    <div class="banner-single-slider slider-item-2">
      <div class="slider-offset"></div>
    </div>
  </div>
  <div class="banner-text">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner-search">
            <h2>We would love you to join TelOne family.</h2>
            <!-- <h4>Search a job which suits you! </h4>
            <form>
              <div class="banner-form-box">
                <div class="banner-form-input">
                  <input type="text" placeholder="Vacancy Reference number">
                </div>
                <div class="banner-form-input">
                  <select class="banner-select">
                    <option selected>Select Department</option>
                    <option value="1">Human Resources</option>
                    <option value="2">Network</option>
                    <option value="3">Accounting/finance</option>
                    <option value="4">Sales</option>
                    <option value="5">Information Systems</option>
                    <option value="6">Digital Marketing</option>
                  </select>
                </div>
                <div class="banner-form-input">
                  <button type="submit"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </form> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Banner Area End -->

<!-- Categories Area Start -->
<section class="jobguru-categories-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="site-heading">
          <h2>Browse <span>Categories</span></h2>
          <p>List of number of vacancies under each department.</p>
        </div>
      </div>
    </div>
    <div class="row" id="ccenter">
      <div
        class="col-lg-3 col-md-6 col-sm-6"
        *ngFor="let department of departments"
      >
        <a
          href="#"
          routerLink="/vacancies/list/{{ department.departmentId }}"
          class="single-category-holder account_cat"
        >
          <div class="category-holder-text">
            <button
              class="btn btn-default"
              type="button"
              style="background-color: #0683f2; height: 20%"
            >
              <i class="fa-alph" style="color: white">{{
                department.activeVacancies
              }}</i>
            </button>
            <br />
            <h3>{{ department.departmentName }}</h3>
          </div>
          <img src="./assets/dist/img/account_cat.jpg" alt="category" />
        </a>
      </div>
    </div>

    <!-- <div class="row">
       <div class="col-md-12">
          <div class="load-more">
             <a href="#" class="jobguru-btn">browse all categories</a>
          </div>
       </div>
    </div> -->
  </div>
</section>
<!-- Categories Area End -->

<!-- Inner Hire Area Start -->
<section class="jobguru-inner-hire-area section_100">
  <div class="hire_circle"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="inner-hire-left">
          <h3>TelOne Careers</h3>
          <p>
            TelOne is always looking for young passionate, talented people to
            join the TelOne family. We help you nourish your career whilst you
            also work on your best to deliver the best of your duties to the
            company's growth and also not forgetting to satisfy the customers
            needs.
          </p>
          <!-- <p>TelOne is always looking for young passionate, talented people to join to the TelOne family. We help you nourish your career whilst you also work on your best to deliver the best of your duties to the companies growth and also not forgetting to satisfy the customers needs.</p> -->
          <!-- <a href="#" class="jobguru-btn-3">sign up as company</a> -->
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Inner Hire Area End -->

<!-- How Works Area Start -->
<section class="how-works-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="site-heading">
          <h2>how it <span>works</span></h2>
          <p>
            It's easy. Simply create your profile, upload necessary documents
            and apply. <br />
            Then you can track the progress of your application.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="how-works-box box-1">
          <img src="./assets/dist/img/arrow-right-top1.png" alt="works" />
          <div class="works-box-icon">
            <i class="fa fa-sign-in"></i>
          </div>
          <div class="works-box-text">
            <p>sign up</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="how-works-box box-2">
          <img src="./assets/dist/img/arrow-right-bottom1.png" alt="works" />
          <div class="works-box-icon">
            <i class="fa fa-pencil"></i>
          </div>
          <div class="works-box-text">
            <p>update profile</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="how-works-box box-3">
          <div class="works-box-icon">
            <i class="fa fa-thumbs-up"></i>
          </div>
          <div class="works-box-text">
            <p>apply to vacancy</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- How Works Area End -->

<!-- Video Area Start -->
<section class="jobguru-video-area section_100">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="video-container">
          <h2>
            Make sure you always update your profile <br />
            before applying for a new vacancy.
          </h2>
          <div class="video-btn">
            <!-- <a class="popup-youtube" href="https://www.youtube.com/watch?v=k-R6AFn9-ek">
            <i class="fa fa-play"></i>
            how it works
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

